import React from "react";
import { Box, Grid, Typography, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import styled from "styled-components";
import Stack from '@mui/material/Stack';

import DonutChart from "../../../components/oeeDashboard/DonutChart";
import { BoxValue, Header, LabelHeader, SubLabelHeader, BoxCost } from "../styles";
import { theme } from "../styles/theme";

const GridPerformance = styled(Grid)`
  @media (max-width: 1200px) {
    margin-top: 20px;
  }
`;

const LabelPerformance = styled(Typography)`
  font-size: clamp(16px, 4vw, 22px) !important;
`;

export default function Overview({
  setSelectedDate,
  selectedDate,
  oeeDashboard,
  eletricity,
  fuel,
  water,
  cost,
  productCost,
  data,

}) {
  /** Color Functions */
  const colorGraphOee = (value) => {
    if (value >= 80) return theme.colorStatus.green;
    if (value >= 60) return theme.colorStatus.yellow;
    return theme.colorStatus.red;
  };

  const colorGraph = (value) => {
    if (value >= 80) return theme.colorStatus.green;
    if (value >= 60) return theme.colorStatus.yellow;
    return theme.colorStatus.red;
  };

  const colorPerformance = () => theme.colorStatus.green;

  const colorYield = () => theme.colorStatus.yellow;


  return (
    <>
      {/* ---------------- HEADER ---------------- */}
      <Header>
        <Grid container justifyContent="space-between" alignItems="center">
          <LabelHeader fontWeight={800}>Production</LabelHeader>
          <LabelHeader fontWeight={800} className="gradient-text">
            {oeeDashboard?.LINE === undefined ? 'LINE7' : oeeDashboard?.LINE}
          </LabelHeader>
        </Grid>

        <Grid container justifyContent="space-between" alignItems="center">
          <SubLabelHeader>OEE OVERVIEW DASHBOARD</SubLabelHeader>

          {/* ---------- Date Picker ---------- */}
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={selectedDate}
                onChange={(newValue) => setSelectedDate(newValue)}
                inputFormat="D MMM YYYY"
                minDate={dayjs().subtract(7, "day")}
                maxDate={dayjs()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    sx={{
                      svg: { color: '#fff' },
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#fff",
                      backgroundColor: "#607D7D",
                      borderRadius: "4px",
                      px: 1,
                      cursor: "pointer",
                      width: "123px",
                      "& input": {
                        textAlign: "center",
                        width: "100px",
                      },
                      "& .MuiInput-underline:before": { borderBottom: "none" },
                      "& .MuiInput-underline:after": { borderBottom: "none" },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                      },
                      background: "transparent",
                      paddingRight: "0px",
                    }}
                  />
                )}
              />
            </LocalizationProvider>

            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={1}>
                <DatePicker
                  value={selectedDate}
                  onChange={(newValue) => setSelectedDate(newValue)}
                  inputFormat="D MMM YYYY"
                  minDate={dayjs().subtract(1, "day")}
                  maxDate={dayjs()}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        width: '75%',
                        svg: { color: '#000000' },
                        "& .MuiOutlinedInput-input": {
                          color: "#000000",
                          //fontFamily: 'Monospace',
                          fontWeight: "bold",
                          fontSize: 16
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                          },
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            </LocalizationProvider> */}
          </Box>
        </Grid>
      </Header>

      {/* ---------------- TOP DONUTS ---------------- */}
      <Grid
        container
        spacing={0}
        mt={2}
        ml={1}
        mr={3}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* OEE */}
        <Grid item lg={4} md={6} xs={6} display="flex" justifyContent="center">
          <DonutChart
            value={oeeDashboard?.OVERVIEW_OEE === undefined || oeeDashboard?.OVERVIEW_OEE === 'NA' || oeeDashboard?.OVERVIEW_OEE === '-' ? 0 : Math.round(oeeDashboard?.OVERVIEW_OEE)}
            target={oeeDashboard?.OVERVIEW_OEE_STD}
            actualColor={colorGraphOee(oeeDashboard?.OVERVIEW_OEE)}
            text="OEE"
          />
        </Grid>

        {/* AVA */}
        <Grid
          item
          lg={2.5}
          md={5}
          xs={5}
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          <Typography fontSize={22} fontWeight={800}>
            AVA
          </Typography>
          <DonutChart
            value={oeeDashboard?.OVERVIEW_A === undefined || oeeDashboard?.OVERVIEW_A === 'NA' || oeeDashboard?.OVERVIEW_A === '-' ? 0 : Math.round(oeeDashboard?.OVERVIEW_A)}
            target={oeeDashboard?.OVERVIEW_A_STD}
            actualColor={colorGraph(oeeDashboard?.OVERVIEW_A)}
            showText={false}
            valueSize="clamp(12px, 6vw, 30px)"
          />
        </Grid>

        {/* PER */}
        <Grid
          item
          lg={2.5}
          md={5}
          xs={5}
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          <Typography fontSize={22} fontWeight={800}>
            PER
          </Typography>
          <DonutChart
            value={oeeDashboard?.OVERVIEW_P === undefined || oeeDashboard?.OVERVIEW_P === 'NA' || oeeDashboard?.OVERVIEW_P === '-' ? 0 : Math.round(oeeDashboard?.OVERVIEW_P)}
            target={oeeDashboard?.OVERVIEW_P_STD}
            actualColor={colorGraph(oeeDashboard?.OVERVIEW_P)}
            showText={false}
            valueSize="clamp(12px, 6vw, 30px)"
          />
        </Grid>

        {/* QUA */}
        <Grid
          item
          lg={2.5}
          md={5}
          xs={5}
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          <Typography fontSize={22} fontWeight={800}>
            QUA
          </Typography>
          <DonutChart
            value={oeeDashboard?.OVERVIEW_Q === undefined || oeeDashboard?.OVERVIEW_Q === 'NA' || oeeDashboard?.OVERVIEW_Q === '-' || oeeDashboard?.OVERVIEW_Q === 0 ? 100 : Math.round(oeeDashboard?.OVERVIEW_Q)}
            target={oeeDashboard?.OVERVIEW_Q_STD}
            actualColor={colorGraph(oeeDashboard?.OVERVIEW_Q)}
            showText={false}
            valueSize="clamp(12px, 6vw, 30px)"
          />
        </Grid>
      </Grid>

      {/* ---------------- PERFORMANCE + YIELD ---------------- */}
      <Grid container>
        <Grid item xl={5} lg={3} md={12} xs={12}></Grid>

        <GridPerformance item xl={7} lg={9} md={12} xs={12}>
          {/* PERFORMANCE */}
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={1}
          >
            <LabelPerformance mr={1}>Performance</LabelPerformance>

            <BoxValue
              mr={1}
              fontSize="clamp(16px, 4vw, 25px) !important"
              color={colorPerformance(oeeDashboard?.OVERVIEW_P_KG_PER_HOUR === undefined ? '#fff' : oeeDashboard?.OVERVIEW_P_KG_PER_HOUR)}
            >
              {oeeDashboard?.OVERVIEW_P_KG_PER_HOUR === undefined || oeeDashboard?.OVERVIEW_P_KG_PER_HOUR === '-' || oeeDashboard?.OVERVIEW_P_KG_PER_HOUR === 'NA' ? '-' : Math.round(oeeDashboard?.OVERVIEW_P_KG_PER_HOUR).toLocaleString()}
            </BoxValue>

            <LabelPerformance mr={1}>kg/hr</LabelPerformance>

            <LabelPerformance color={theme.palette.text.gray}>
              (std. {oeeDashboard?.OVERVIEW_KG_PER_HOUR_STD === undefined || oeeDashboard?.OVERVIEW_KG_PER_HOUR_STD === '-' || oeeDashboard?.OVERVIEW_KG_PER_HOUR_STD === 'NA' ? '-' : Math.round(oeeDashboard?.OVERVIEW_KG_PER_HOUR_STD).toLocaleString()})
            </LabelPerformance>
          </Grid>

          {/* YIELD */}
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <LabelPerformance mr={1} pl="31px">
              Yield
            </LabelPerformance>

            <BoxValue
              mr={1}
              fontSize="clamp(16px, 4vw, 25px) !important"
              color={colorYield(oeeDashboard?.OVERVIEW_YIELD === undefined ? '#fff' : oeeDashboard?.OVERVIEW_YIELD)}
            >
              {oeeDashboard?.SKU_COMPLETED === undefined || oeeDashboard?.SKU_COMPLETED === 'NA' || oeeDashboard?.SKU_COMPLETED === '-' || oeeDashboard?.SKU_COMPLETED === 0 ? '-' : (oeeDashboard?.OVERVIEW_YIELD === undefined || oeeDashboard?.OVERVIEW_YIELD === 'NA' || oeeDashboard?.OVERVIEW_YIELD === '-' ? '-' : Math.round(oeeDashboard?.OVERVIEW_YIELD).toLocaleString())}
            </BoxValue>

            <LabelPerformance mr={1}>%</LabelPerformance>

            <LabelPerformance color={theme.palette.text.gray}>
              (std. {oeeDashboard?.OVERVIEW_YIELD_STD === undefined || oeeDashboard?.OVERVIEW_YIELD_STD === 'NA' || oeeDashboard?.OVERVIEW_YIELD_STD === '-' ? '-' : Math.round(oeeDashboard?.OVERVIEW_YIELD_STD).toLocaleString()})
            </LabelPerformance>
          </Grid>
        </GridPerformance>
      </Grid>

      {/* ---------------- ENERGY COST ---------------- */}
      <Header mt={4}>ENERGY COST</Header>

      <Grid container mt={2}>
        {/* Electric */}
        <Grid item xs={7}>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={1}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Energy.png`}
              width={30}
              alt="Steam"
              style={{ marginRight: 10 }}
            />
            <BoxCost mr={1}>
              {eletricity}
            </BoxCost>
            <LabelPerformance color={theme.palette.text.gray}>
              ฿
            </LabelPerformance>
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={1}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/EnergyCost_Fuel.png`}
              width={30}
              alt="Steam"
              style={{ marginRight: 10 }}
            />
            <BoxCost mr={1}>
              {fuel}
            </BoxCost>
            <LabelPerformance color={theme.palette.text.gray}>
              ฿
            </LabelPerformance>
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={1}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/EnergyCost_Water.png`}
              width={30}
              alt="Water"
              style={{ marginRight: 10 }}
            />
            <BoxCost mr={1}>
              {water}
            </BoxCost>
            <LabelPerformance color={theme.palette.text.gray}>
              ฿
            </LabelPerformance>
          </Grid>
        </Grid>

        {/* Total Bath */}
        <Grid item xs={5}>
          <Grid mr={1} style={{ padding: '20px 10px' }} textAlign='right'>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="center"
              alignItems="center"

            >
              <Grid container mt={1}>
                <Grid item xs={6}>
                  <LabelPerformance
                    color={theme.palette.text.customGreen}
                    fontSize="clamp(16px, 4vw, 25px) !important"
                    mr={1}
                    fontWeight={800}
                  >
                    {cost}
                  </LabelPerformance>
                </Grid>
                <Grid item xs={2} alignItems={"left"}>
                  <LabelPerformance mr={1}>฿</LabelPerformance>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="center"
              alignItems="center"

            >
              <Grid container mt={1}>
                <Grid item xs={6}>
                  <LabelPerformance
                    color={theme.palette.text.customGreen}
                    fontSize="clamp(16px, 4vw, 25px) !important"
                    mr={1}
                    fontWeight={800}
                  >
                    {productCost}
                  </LabelPerformance>
                </Grid>
                <Grid item xs={3.5} alignItems={"left"}>
                  <LabelPerformance mr={1}>฿/kg</LabelPerformance>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
